













import { Component, Prop, Vue } from 'vue-property-decorator'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'

@Component({
  inheritAttrs: false,
  components: { DropdownSelect },
})
export default class DropBoxDropdown extends Vue {
  @Prop({ required: true }) private fieldLabel!: string
  @Prop({ default: false }) private required!: boolean
  @Prop() private errorMessage!: string
}
